import * as React from 'react'

const Star = (props: any) => (
  <svg {...props} viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 0L6 5.74468H0L5 9.25532L3 15L8 11.4894L13 15L11 9.25532L16 5.74468H10L8 0Z'
    />
  </svg>
)

export default Star



// WEBPACK FOOTER //
// ./src/components/icons/ui/Star.tsx